<script setup>
defineProps({
  url: {
    type: String,
    default: () => '',
  },
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div class="pages-cards__item">
    <CTagDetect v-if="url" :to="url" class="pages-cards__item-wrap">
      <div v-if="image" class="pages-cards__item-media">
        <NuxtImg
          v-if="image?.src"
          :src="image.src"
          :alt="image.alt"
          :height="image.height"
          :width="image.width"
          class="pages-cards__item-image"
          loading="lazy"
        />
      </div>
      <div class="pages-cards__item-info">
        <p
          v-if="title"
          class="m-0 pages-cards__item-title h4"
          :class="[backgroundColor === 'black' ? 'white' : '']"
          v-html="title"
        ></p>
        <div
          v-if="description"
          class="pages-cards__item-description body-3-regular"
          :class="[backgroundColor === 'black' ? 'white' : '']"
          v-html="description"
        ></div>
      </div>
    </CTagDetect>
    <div v-else class="pages-cards__item-wrap">
      <div v-if="image" class="pages-cards__item-media">
        <NuxtImg
          v-if="image?.src"
          :src="image.src"
          :alt="image.alt"
          :height="image.height"
          :width="image.width"
          class="pages-cards__item-image"
          loading="lazy"
        />
      </div>
      <div class="pages-cards__item-info">
        <p
          v-if="title"
          class="m-0 pages-cards__item-title h4"
          :class="[backgroundColor === 'black' ? 'white' : '']"
          v-html="title"
        ></p>
        <div
          v-if="description"
          class="pages-cards__item-description body-2-regular"
          :class="[backgroundColor === 'black' ? 'white' : '']"
          v-html="description"
        ></div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.pages-cards__item {
  $parent: &;
  &-wrap {
    display: flex;
    flex-direction: column;
    gap: 24px;
    @include media-breakpoint-up(sm) {
      gap: 40px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 40);
    }
  }
  &-media {
    border-radius: 8px;
    aspect-ratio: 312/216;
    overflow: hidden;
    @include media-breakpoint-up(sm) {
      aspect-ratio: 340/240;
    }
    @include media-breakpoint-up(sm) {
      aspect-ratio: 584/400;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
    }
  }
  &-image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &-info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 82.1%;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
  &-title {
    word-wrap: break-word;
  }
  &-description {
    &:deep(p:last-child) {
      margin: 0;
    }
  }
}
</style>
